<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>
  <div class="main-panel">
    <header class="topbar">
      <h1>Patrocinio</h1>
      <div class="topbar-right">
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>
    <div class="content-breadcrumbs">
      <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    </div>
    <app-patrocinio-panel [rol]="rol"></app-patrocinio-panel>
  </div>
</div>
